// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: quick-trade.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Empty } from "./google/protobuf/empty";
import { Condition } from "./nexus";
import {
  Broker_OrderType,
  broker_OrderTypeFromJSON,
  broker_OrderTypeToJSON,
  TransactionType,
  transactionTypeFromJSON,
  transactionTypeToJSON,
} from "./order";
import { Security } from "./security";
import { StrategyTemplateLegsProto } from "./strategy";

export const protobufPackage = "com.tick2trade.api.draco.quicktrade";

export enum QuoteType {
  QUOTE_TYPE_UNKNOWN = 0,
  BIPS = 1,
  LEVEL = 2,
  TICKS = 3,
  UNRECOGNIZED = -1,
}

export function quoteTypeFromJSON(object: any): QuoteType {
  switch (object) {
    case 0:
    case "QUOTE_TYPE_UNKNOWN":
      return QuoteType.QUOTE_TYPE_UNKNOWN;
    case 1:
    case "BIPS":
      return QuoteType.BIPS;
    case 2:
    case "LEVEL":
      return QuoteType.LEVEL;
    case 3:
    case "TICKS":
      return QuoteType.TICKS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QuoteType.UNRECOGNIZED;
  }
}

export function quoteTypeToJSON(object: QuoteType): string {
  switch (object) {
    case QuoteType.QUOTE_TYPE_UNKNOWN:
      return "QUOTE_TYPE_UNKNOWN";
    case QuoteType.BIPS:
      return "BIPS";
    case QuoteType.LEVEL:
      return "LEVEL";
    case QuoteType.TICKS:
      return "TICKS";
    case QuoteType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SlTargetValueType {
  SL_TARGET_VALUE_TYPE_UNKNOWN = 0,
  POINTS = 1,
  PERCENTAGE = 2,
  MTM = 3,
  UNRECOGNIZED = -1,
}

export function slTargetValueTypeFromJSON(object: any): SlTargetValueType {
  switch (object) {
    case 0:
    case "SL_TARGET_VALUE_TYPE_UNKNOWN":
      return SlTargetValueType.SL_TARGET_VALUE_TYPE_UNKNOWN;
    case 1:
    case "POINTS":
      return SlTargetValueType.POINTS;
    case 2:
    case "PERCENTAGE":
      return SlTargetValueType.PERCENTAGE;
    case 3:
    case "MTM":
      return SlTargetValueType.MTM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SlTargetValueType.UNRECOGNIZED;
  }
}

export function slTargetValueTypeToJSON(object: SlTargetValueType): string {
  switch (object) {
    case SlTargetValueType.SL_TARGET_VALUE_TYPE_UNKNOWN:
      return "SL_TARGET_VALUE_TYPE_UNKNOWN";
    case SlTargetValueType.POINTS:
      return "POINTS";
    case SlTargetValueType.PERCENTAGE:
      return "PERCENTAGE";
    case SlTargetValueType.MTM:
      return "MTM";
    case SlTargetValueType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum QuickTradeType {
  Quick_TRADE_TYPE_UNKNOWN = 0,
  TEMPLATE_ORDER = 1,
  UNRECOGNIZED = -1,
}

export function quickTradeTypeFromJSON(object: any): QuickTradeType {
  switch (object) {
    case 0:
    case "Quick_TRADE_TYPE_UNKNOWN":
      return QuickTradeType.Quick_TRADE_TYPE_UNKNOWN;
    case 1:
    case "TEMPLATE_ORDER":
      return QuickTradeType.TEMPLATE_ORDER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QuickTradeType.UNRECOGNIZED;
  }
}

export function quickTradeTypeToJSON(object: QuickTradeType): string {
  switch (object) {
    case QuickTradeType.Quick_TRADE_TYPE_UNKNOWN:
      return "Quick_TRADE_TYPE_UNKNOWN";
    case QuickTradeType.TEMPLATE_ORDER:
      return "TEMPLATE_ORDER";
    case QuickTradeType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface QuickTradeProto {
  id: string;
  actionName: string;
  type: QuickTradeType;
  referenceId: string;
  security?: Security | undefined;
  templateOrderExecutionParameters?: TemplateOrderExecutionParameters | undefined;
  description?: string | undefined;
}

export interface QuickTradesProto {
  quickTrades: QuickTradeProto[];
}

export interface TemplateOrderExecutionParameters {
  brokerOrderType: Broker_OrderType;
  quoteType?: QuoteType | undefined;
  quoteValue?: number | undefined;
  multiplier?: number | undefined;
  amount?: number | undefined;
  lots?: number | undefined;
  quantity?: number | undefined;
  strategyLegs?: StrategyTemplateLegsProto | undefined;
  transactionType?: TransactionType | undefined;
  addStopLoss?: boolean | undefined;
  stopLoss?: number | undefined;
  stopLossType?: SlTargetValueType | undefined;
  addTarget?: boolean | undefined;
  target?: number | undefined;
  targetType?: SlTargetValueType | undefined;
  addConditionalEntry?: boolean | undefined;
  conditionalEntryCondition?: Condition | undefined;
  addConditionalExit?: boolean | undefined;
  conditionalExitCondition?: Condition | undefined;
}

function createBaseQuickTradeProto(): QuickTradeProto {
  return {
    id: "",
    actionName: "",
    type: 0,
    referenceId: "",
    security: undefined,
    templateOrderExecutionParameters: undefined,
    description: undefined,
  };
}

export const QuickTradeProto = {
  encode(message: QuickTradeProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.actionName !== "") {
      writer.uint32(18).string(message.actionName);
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    if (message.referenceId !== "") {
      writer.uint32(34).string(message.referenceId);
    }
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(42).fork()).ldelim();
    }
    if (message.templateOrderExecutionParameters !== undefined) {
      TemplateOrderExecutionParameters.encode(message.templateOrderExecutionParameters, writer.uint32(50).fork())
        .ldelim();
    }
    if (message.description !== undefined) {
      writer.uint32(66).string(message.description);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): QuickTradeProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuickTradeProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.actionName = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.referenceId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.templateOrderExecutionParameters = TemplateOrderExecutionParameters.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.description = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QuickTradeProto {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      actionName: isSet(object.actionName) ? globalThis.String(object.actionName) : "",
      type: isSet(object.type) ? quickTradeTypeFromJSON(object.type) : 0,
      referenceId: isSet(object.referenceId) ? globalThis.String(object.referenceId) : "",
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      templateOrderExecutionParameters: isSet(object.templateOrderExecutionParameters)
        ? TemplateOrderExecutionParameters.fromJSON(object.templateOrderExecutionParameters)
        : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
    };
  },

  toJSON(message: QuickTradeProto): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.actionName !== "") {
      obj.actionName = message.actionName;
    }
    if (message.type !== 0) {
      obj.type = quickTradeTypeToJSON(message.type);
    }
    if (message.referenceId !== "") {
      obj.referenceId = message.referenceId;
    }
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.templateOrderExecutionParameters !== undefined) {
      obj.templateOrderExecutionParameters = TemplateOrderExecutionParameters.toJSON(
        message.templateOrderExecutionParameters,
      );
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QuickTradeProto>, I>>(base?: I): QuickTradeProto {
    return QuickTradeProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QuickTradeProto>, I>>(object: I): QuickTradeProto {
    const message = createBaseQuickTradeProto();
    message.id = object.id ?? "";
    message.actionName = object.actionName ?? "";
    message.type = object.type ?? 0;
    message.referenceId = object.referenceId ?? "";
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.templateOrderExecutionParameters =
      (object.templateOrderExecutionParameters !== undefined && object.templateOrderExecutionParameters !== null)
        ? TemplateOrderExecutionParameters.fromPartial(object.templateOrderExecutionParameters)
        : undefined;
    message.description = object.description ?? undefined;
    return message;
  },
};

function createBaseQuickTradesProto(): QuickTradesProto {
  return { quickTrades: [] };
}

export const QuickTradesProto = {
  encode(message: QuickTradesProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.quickTrades) {
      QuickTradeProto.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): QuickTradesProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQuickTradesProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.quickTrades.push(QuickTradeProto.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): QuickTradesProto {
    return {
      quickTrades: globalThis.Array.isArray(object?.quickTrades)
        ? object.quickTrades.map((e: any) => QuickTradeProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: QuickTradesProto): unknown {
    const obj: any = {};
    if (message.quickTrades?.length) {
      obj.quickTrades = message.quickTrades.map((e) => QuickTradeProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<QuickTradesProto>, I>>(base?: I): QuickTradesProto {
    return QuickTradesProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<QuickTradesProto>, I>>(object: I): QuickTradesProto {
    const message = createBaseQuickTradesProto();
    message.quickTrades = object.quickTrades?.map((e) => QuickTradeProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTemplateOrderExecutionParameters(): TemplateOrderExecutionParameters {
  return {
    brokerOrderType: 0,
    quoteType: undefined,
    quoteValue: undefined,
    multiplier: undefined,
    amount: undefined,
    lots: undefined,
    quantity: undefined,
    strategyLegs: undefined,
    transactionType: undefined,
    addStopLoss: undefined,
    stopLoss: undefined,
    stopLossType: undefined,
    addTarget: undefined,
    target: undefined,
    targetType: undefined,
    addConditionalEntry: undefined,
    conditionalEntryCondition: undefined,
    addConditionalExit: undefined,
    conditionalExitCondition: undefined,
  };
}

export const TemplateOrderExecutionParameters = {
  encode(message: TemplateOrderExecutionParameters, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.brokerOrderType !== 0) {
      writer.uint32(8).int32(message.brokerOrderType);
    }
    if (message.quoteType !== undefined) {
      writer.uint32(16).int32(message.quoteType);
    }
    if (message.quoteValue !== undefined) {
      writer.uint32(24).int32(message.quoteValue);
    }
    if (message.multiplier !== undefined) {
      writer.uint32(32).int32(message.multiplier);
    }
    if (message.amount !== undefined) {
      writer.uint32(41).double(message.amount);
    }
    if (message.lots !== undefined) {
      writer.uint32(48).int32(message.lots);
    }
    if (message.quantity !== undefined) {
      writer.uint32(56).int32(message.quantity);
    }
    if (message.strategyLegs !== undefined) {
      StrategyTemplateLegsProto.encode(message.strategyLegs, writer.uint32(66).fork()).ldelim();
    }
    if (message.transactionType !== undefined) {
      writer.uint32(72).int32(message.transactionType);
    }
    if (message.addStopLoss !== undefined) {
      writer.uint32(80).bool(message.addStopLoss);
    }
    if (message.stopLoss !== undefined) {
      writer.uint32(89).double(message.stopLoss);
    }
    if (message.stopLossType !== undefined) {
      writer.uint32(96).int32(message.stopLossType);
    }
    if (message.addTarget !== undefined) {
      writer.uint32(104).bool(message.addTarget);
    }
    if (message.target !== undefined) {
      writer.uint32(113).double(message.target);
    }
    if (message.targetType !== undefined) {
      writer.uint32(120).int32(message.targetType);
    }
    if (message.addConditionalEntry !== undefined) {
      writer.uint32(128).bool(message.addConditionalEntry);
    }
    if (message.conditionalEntryCondition !== undefined) {
      Condition.encode(message.conditionalEntryCondition, writer.uint32(138).fork()).ldelim();
    }
    if (message.addConditionalExit !== undefined) {
      writer.uint32(144).bool(message.addConditionalExit);
    }
    if (message.conditionalExitCondition !== undefined) {
      Condition.encode(message.conditionalExitCondition, writer.uint32(154).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TemplateOrderExecutionParameters {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTemplateOrderExecutionParameters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.brokerOrderType = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.quoteType = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.quoteValue = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.multiplier = reader.int32();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.amount = reader.double();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.lots = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.quantity = reader.int32();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.strategyLegs = StrategyTemplateLegsProto.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.transactionType = reader.int32() as any;
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.addStopLoss = reader.bool();
          continue;
        case 11:
          if (tag !== 89) {
            break;
          }

          message.stopLoss = reader.double();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.stopLossType = reader.int32() as any;
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.addTarget = reader.bool();
          continue;
        case 14:
          if (tag !== 113) {
            break;
          }

          message.target = reader.double();
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.targetType = reader.int32() as any;
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.addConditionalEntry = reader.bool();
          continue;
        case 17:
          if (tag !== 138) {
            break;
          }

          message.conditionalEntryCondition = Condition.decode(reader, reader.uint32());
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.addConditionalExit = reader.bool();
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.conditionalExitCondition = Condition.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TemplateOrderExecutionParameters {
    return {
      brokerOrderType: isSet(object.brokerOrderType) ? broker_OrderTypeFromJSON(object.brokerOrderType) : 0,
      quoteType: isSet(object.quoteType) ? quoteTypeFromJSON(object.quoteType) : undefined,
      quoteValue: isSet(object.quoteValue) ? globalThis.Number(object.quoteValue) : undefined,
      multiplier: isSet(object.multiplier) ? globalThis.Number(object.multiplier) : undefined,
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : undefined,
      lots: isSet(object.lots) ? globalThis.Number(object.lots) : undefined,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : undefined,
      strategyLegs: isSet(object.strategyLegs) ? StrategyTemplateLegsProto.fromJSON(object.strategyLegs) : undefined,
      transactionType: isSet(object.transactionType) ? transactionTypeFromJSON(object.transactionType) : undefined,
      addStopLoss: isSet(object.addStopLoss) ? globalThis.Boolean(object.addStopLoss) : undefined,
      stopLoss: isSet(object.stopLoss) ? globalThis.Number(object.stopLoss) : undefined,
      stopLossType: isSet(object.stopLossType) ? slTargetValueTypeFromJSON(object.stopLossType) : undefined,
      addTarget: isSet(object.addTarget) ? globalThis.Boolean(object.addTarget) : undefined,
      target: isSet(object.target) ? globalThis.Number(object.target) : undefined,
      targetType: isSet(object.targetType) ? slTargetValueTypeFromJSON(object.targetType) : undefined,
      addConditionalEntry: isSet(object.addConditionalEntry)
        ? globalThis.Boolean(object.addConditionalEntry)
        : undefined,
      conditionalEntryCondition: isSet(object.conditionalEntryCondition)
        ? Condition.fromJSON(object.conditionalEntryCondition)
        : undefined,
      addConditionalExit: isSet(object.addConditionalExit) ? globalThis.Boolean(object.addConditionalExit) : undefined,
      conditionalExitCondition: isSet(object.conditionalExitCondition)
        ? Condition.fromJSON(object.conditionalExitCondition)
        : undefined,
    };
  },

  toJSON(message: TemplateOrderExecutionParameters): unknown {
    const obj: any = {};
    if (message.brokerOrderType !== 0) {
      obj.brokerOrderType = broker_OrderTypeToJSON(message.brokerOrderType);
    }
    if (message.quoteType !== undefined) {
      obj.quoteType = quoteTypeToJSON(message.quoteType);
    }
    if (message.quoteValue !== undefined) {
      obj.quoteValue = Math.round(message.quoteValue);
    }
    if (message.multiplier !== undefined) {
      obj.multiplier = Math.round(message.multiplier);
    }
    if (message.amount !== undefined) {
      obj.amount = message.amount;
    }
    if (message.lots !== undefined) {
      obj.lots = Math.round(message.lots);
    }
    if (message.quantity !== undefined) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.strategyLegs !== undefined) {
      obj.strategyLegs = StrategyTemplateLegsProto.toJSON(message.strategyLegs);
    }
    if (message.transactionType !== undefined) {
      obj.transactionType = transactionTypeToJSON(message.transactionType);
    }
    if (message.addStopLoss !== undefined) {
      obj.addStopLoss = message.addStopLoss;
    }
    if (message.stopLoss !== undefined) {
      obj.stopLoss = message.stopLoss;
    }
    if (message.stopLossType !== undefined) {
      obj.stopLossType = slTargetValueTypeToJSON(message.stopLossType);
    }
    if (message.addTarget !== undefined) {
      obj.addTarget = message.addTarget;
    }
    if (message.target !== undefined) {
      obj.target = message.target;
    }
    if (message.targetType !== undefined) {
      obj.targetType = slTargetValueTypeToJSON(message.targetType);
    }
    if (message.addConditionalEntry !== undefined) {
      obj.addConditionalEntry = message.addConditionalEntry;
    }
    if (message.conditionalEntryCondition !== undefined) {
      obj.conditionalEntryCondition = Condition.toJSON(message.conditionalEntryCondition);
    }
    if (message.addConditionalExit !== undefined) {
      obj.addConditionalExit = message.addConditionalExit;
    }
    if (message.conditionalExitCondition !== undefined) {
      obj.conditionalExitCondition = Condition.toJSON(message.conditionalExitCondition);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TemplateOrderExecutionParameters>, I>>(
    base?: I,
  ): TemplateOrderExecutionParameters {
    return TemplateOrderExecutionParameters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TemplateOrderExecutionParameters>, I>>(
    object: I,
  ): TemplateOrderExecutionParameters {
    const message = createBaseTemplateOrderExecutionParameters();
    message.brokerOrderType = object.brokerOrderType ?? 0;
    message.quoteType = object.quoteType ?? undefined;
    message.quoteValue = object.quoteValue ?? undefined;
    message.multiplier = object.multiplier ?? undefined;
    message.amount = object.amount ?? undefined;
    message.lots = object.lots ?? undefined;
    message.quantity = object.quantity ?? undefined;
    message.strategyLegs = (object.strategyLegs !== undefined && object.strategyLegs !== null)
      ? StrategyTemplateLegsProto.fromPartial(object.strategyLegs)
      : undefined;
    message.transactionType = object.transactionType ?? undefined;
    message.addStopLoss = object.addStopLoss ?? undefined;
    message.stopLoss = object.stopLoss ?? undefined;
    message.stopLossType = object.stopLossType ?? undefined;
    message.addTarget = object.addTarget ?? undefined;
    message.target = object.target ?? undefined;
    message.targetType = object.targetType ?? undefined;
    message.addConditionalEntry = object.addConditionalEntry ?? undefined;
    message.conditionalEntryCondition =
      (object.conditionalEntryCondition !== undefined && object.conditionalEntryCondition !== null)
        ? Condition.fromPartial(object.conditionalEntryCondition)
        : undefined;
    message.addConditionalExit = object.addConditionalExit ?? undefined;
    message.conditionalExitCondition =
      (object.conditionalExitCondition !== undefined && object.conditionalExitCondition !== null)
        ? Condition.fromPartial(object.conditionalExitCondition)
        : undefined;
    return message;
  },
};

export interface QuickTradeService {
  GetQuickTrades(request: Empty): Promise<QuickTradesProto>;
  CreateQuickTrade(request: QuickTradeProto): Promise<QuickTradeProto>;
  ModifyQuickTrade(request: QuickTradeProto): Promise<QuickTradeProto>;
  DeleteQuickTrade(request: QuickTradeProto): Promise<Empty>;
}

export const QuickTradeServiceServiceName = "com.tick2trade.api.draco.quicktrade.QuickTradeService";
export class QuickTradeServiceClientImpl implements QuickTradeService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || QuickTradeServiceServiceName;
    this.rpc = rpc;
    this.GetQuickTrades = this.GetQuickTrades.bind(this);
    this.CreateQuickTrade = this.CreateQuickTrade.bind(this);
    this.ModifyQuickTrade = this.ModifyQuickTrade.bind(this);
    this.DeleteQuickTrade = this.DeleteQuickTrade.bind(this);
  }
  GetQuickTrades(request: Empty): Promise<QuickTradesProto> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetQuickTrades", data);
    return promise.then((data) => QuickTradesProto.decode(_m0.Reader.create(data)));
  }

  CreateQuickTrade(request: QuickTradeProto): Promise<QuickTradeProto> {
    const data = QuickTradeProto.encode(request).finish();
    const promise = this.rpc.request(this.service, "CreateQuickTrade", data);
    return promise.then((data) => QuickTradeProto.decode(_m0.Reader.create(data)));
  }

  ModifyQuickTrade(request: QuickTradeProto): Promise<QuickTradeProto> {
    const data = QuickTradeProto.encode(request).finish();
    const promise = this.rpc.request(this.service, "ModifyQuickTrade", data);
    return promise.then((data) => QuickTradeProto.decode(_m0.Reader.create(data)));
  }

  DeleteQuickTrade(request: QuickTradeProto): Promise<Empty> {
    const data = QuickTradeProto.encode(request).finish();
    const promise = this.rpc.request(this.service, "DeleteQuickTrade", data);
    return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
